export const CHIRA_CEO_URL = 'https://onlystory.co.jp/service/'
export const CHIRA_CEO_CASE_URL = `${CHIRA_CEO_URL}/case`
export const HELP_URL = 'https://intercom.help/-88027c91a408/ja'
export const EVENTS_URL = 'https://only-story.jp/meetup/'
export const APP_LP_URL = 'https://onlystory.co.jp/service/'
export const MESEHO_URL = 'https://only-story.jp/meseho/'
export const HIRING_URL =
  'https://www.wantedly.com/companies/onlystory?_fsi=QBBBg4lm'
export const NOTE_URL = 'https://note.com/onlystory_hirano?_fsi=R1sl8ISN'
export const RECOMMENDATION_BROCHURE_URL =
  'https://drive.google.com/file/d/1ddm4WAIVzuRcIS-HCZcSvZAmKCv5Z7l4/view?_fsi=8Ps5eLvW'

export const FORGOT_ID_AND_PASSWORD_URL =
  'https://form.run/@chira-ceo-1598316452'
export const PAID_PLAN_CONTACT_URL = 'https://onlystory.co.jp/service/contact/'

export const CAMPAIGN_1_URL =
  'https://form.run/@onlystory-1647853051?utm_source=sitetop&utm_medium=banner-2'
export const CAMPAIGN_4_URL =
  'https://form.run/@onlystory-1647853051?utm_source=sitetop&utm_medium=banner-1'
export const CAMPAIGN_5_URL =
  'https://form.run/@onlystory-share-campaign?utm_source=sitetop&utm_medium=banner-a'
